import { amazonMusic } from './providers/amazon';
import { appleMusic } from './providers/apple';
import { deezer } from './providers/deezer';
import { spotify } from './providers/spotify';
import { twitch } from './providers/twitch';
import { vimeo } from './providers/vimeo';
import { youtube } from './providers/youtube';
var providers = [
    youtube,
    spotify,
    twitch,
    vimeo,
    deezer,
    appleMusic,
    amazonMusic,
];
export var getPlayerExecutionProps = function (link, category) {
    var _a;
    return (_a = providers
        .find(function (provider) {
        return provider.isSatisfied(link) &&
            (!category || provider.category === category);
    })) === null || _a === void 0 ? void 0 : _a.getPlayerExecutionProps(link);
};
